import axiosInstance from './axiosInstance';

const getQRArsAdvanced = (merchantId) =>
  axiosInstance.get(`/internal/admin/merchants/${merchantId}/qr_ars_advanced`);

export default getQRArsAdvanced;
